import FormattedMessage from 'I18n/components/FormattedMessage';
import { Small } from 'foundations-components/transitional/components/Small';
import { WarningIcon } from 'foundations-assets';
import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
import styled from 'styled-components';
import { stripZeroWidthCharacters } from 'svh-workspace-ui-lib/preview-card/public/operators';
import { AttachmentType } from 'svh-workspace-ui-lib/preview-card/public/components/AttachmentType';
import InboxSLAOnboardingModal from 'svh-workspace-ui-lib/preview-card/public/components/InboxSLAOnboardingModal';
import { PreviewCardContentWrapper, PreviewCardContentTextWrapper, PreviewCardContentHeaderWrapper } from './PreviewCardStyles';
import ResponseStatusIcon from 'svh-workspace-ui-lib/preview-card/public/components/ResponseStatusIcon';
import PreviewCardSLAIcon from 'svh-workspace-ui-lib/preview-card/public/components/PreviewCardSLAIcon';
import LineClamp from '../../common/components/LineClamp';
import I18n from 'I18n';
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PublishFailedError = () => /*#__PURE__*/_jsxs(Small, {
  use: "error",
  children: [/*#__PURE__*/_jsx(View, {
    as: "span",
    marginInlineEnd: "100",
    children: /*#__PURE__*/_jsx(WarningIcon, {
      size: "300"
    })
  }), /*#__PURE__*/_jsx(FormattedMessage, {
    message: "conversations-inbox-ui.preview-card.PUBLISH_FAILED.message"
  })]
});
PublishFailedError.displayName = 'PublishFailedError';
export const SLAIconWrapper = styled.div.withConfig({
  displayName: "PreviewCardContent__SLAIconWrapper",
  componentId: "sc-1giaw4p-0"
})(["position:absolute;right:12px;bottom:12px;"]);
const PreviewCardContent = ({
  forwarded,
  isComment,
  isUnread,
  hasNoConversation,
  publishFailed,
  repliedTo,
  slaStatus,
  secondaryHeader,
  isNameHeader,
  isUnknownContact,
  textPreview,
  showInboxSLATour,
  onInboxSLATourOpen,
  onInboxSLATourClose,
  attachmentTypes,
  shouldDisableSLA,
  isLatestMessageADraft
}) => {
  const getPreviewText = preview => {
    if (isLatestMessageADraft) {
      return `${I18n.text('conversations-inbox-ui.preview-card.draftPlaceholder')} ${stripZeroWidthCharacters(preview)}`;
    }
    return stripZeroWidthCharacters(preview);
  };
  if (publishFailed) {
    return /*#__PURE__*/_jsx(PreviewCardContentWrapper, {
      children: /*#__PURE__*/_jsx(PublishFailedError, {
        "data-test-id": "publish-failed"
      })
    });
  }
  return /*#__PURE__*/_jsxs(PreviewCardContentWrapper, {
    "data-test-id": "member-context",
    children: [secondaryHeader && /*#__PURE__*/_jsx(Flex, {
      inlineSize: "100%",
      flexDirection: "row",
      children: /*#__PURE__*/_jsx(PreviewCardContentHeaderWrapper, {
        isUnread: isUnread,
        isUnknownContact: isNameHeader && isUnknownContact,
        children: /*#__PURE__*/_jsx(LineClamp, {
          maxLines: 1,
          children: /*#__PURE__*/_jsx(TruncateString, {
            tooltip: !isNameHeader,
            children: secondaryHeader
          })
        })
      })
    }), /*#__PURE__*/_jsx(Flex, {
      inlineSize: "100%",
      flexDirection: "row",
      children: /*#__PURE__*/_jsx(PreviewCardContentTextWrapper, {
        isComment: isComment,
        isUnread: isUnread,
        hasSLA: !!slaStatus,
        hasNoConversation: hasNoConversation,
        "data-test-id": "member-preview",
        children: /*#__PURE__*/_jsx(LineClamp, {
          maxLines: secondaryHeader ? 1 : 2,
          children: /*#__PURE__*/_jsxs(TruncateString, {
            children: [/*#__PURE__*/_jsx(ResponseStatusIcon, {
              forwarded: forwarded,
              repliedTo: repliedTo
            }), textPreview && /*#__PURE__*/_jsx("span", {
              children: getPreviewText(textPreview)
            }), !textPreview && attachmentTypes && /*#__PURE__*/_jsx(AttachmentType, {
              attachmentTypes: attachmentTypes,
              repliedTo: repliedTo
            })]
          })
        })
      })
    }), !shouldDisableSLA && /*#__PURE__*/_jsx(SLAIconWrapper, {
      children: showInboxSLATour ? /*#__PURE__*/_jsx(InboxSLAOnboardingModal, {
        onInboxSLATourOpen: onInboxSLATourOpen,
        onInboxSLATourClose: onInboxSLATourClose,
        children: /*#__PURE__*/_jsx(PreviewCardSLAIcon, {
          status: slaStatus
        })
      }) : /*#__PURE__*/_jsx(PreviewCardSLAIcon, {
        status: slaStatus
      })
    })]
  });
};
PreviewCardContent.displayName = 'PreviewCardContent';
export default PreviewCardContent;